import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthInterceptor } from 'app/core/auth/auth.interceptor';
import { SessionWarningDialogComponent } from 'app/core/auth/session-warning-dialog/session-warning-dialog.component';

@NgModule({ declarations: [
        SessionWarningDialogComponent
    ], imports: [CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule], providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AuthModule
{
}
